export function useInversionFail() {
	return false

	// const engine = useEngine()
	// const objectifs = useSelector(configObjectifsSelector).map(
	// 	(objectif) => engine.evaluate(objectif).nodeValue
	// )

	// const inversionFail =
	// 	engine.inversionFail() && objectifs.some((o) => o === undefined)

	// return inversionFail
}
